import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Shield, Folder } from "@mui/icons-material";
import { Badge, OptionCardGroup, StepActions, PageHeader } from "@components/ui_v2";
import { PATHS_TOFU_V2 } from "@helpers/constantes";

export const DecisionIngreso = () => {
  const navigate = useNavigate();
  const [viaIngreso, setViaIngreso] = useState<"sat" | "docs" | "">("");

  const onBack = () => navigate(PATHS_TOFU_V2.validacionTelefono.path);
  // La rama documental sustituye a la conexion con el SAT por la carga manual de estados financieros.
  const onNext = () =>
    navigate(`/v2/producto/creditosimple/${viaIngreso === "docs" ? "carga_documentos" : "consulta_ciec"}`);

  return (
    <Box>
      <PageHeader
        eyebrow="Decisión"
        title="¿Cómo quieres declarar tus ingresos?"
        subtitle="Elige la vía con la que compartirás la información financiera de tu empresa. Puedes cambiar tu selección antes de continuar."
      />

      <Box sx={{ mt: "4px" }}>
        <OptionCardGroup
          value={viaIngreso}
          onChange={(v) => setViaIngreso(v as "sat" | "docs")}
          options={[
            {
              value: "sat",
              icon: <Shield />,
              label: (
                <>
                  Conectar con el SAT <Badge tone="ok">Recomendada</Badge>
                </>
              ),
              sub: "Proporciona tu contraseña CIEC y obtenemos tus datos fiscales automáticamente. Es el camino más rápido.",
              testId: "decision-ingreso-sat-option",
            },
            {
              value: "docs",
              icon: <Folder />,
              label: "Entregar documentos",
              sub: "Si prefieres no compartir tu CIEC, sube manualmente los documentos financieros de tu empresa.",
              testId: "decision-ingreso-docs-option",
            },
          ]}
        />
      </Box>

      <StepActions
        onBack={onBack}
        onNext={onNext}
        nextDisabled={!viaIngreso}
        backTestId="decision-ingreso-back-button"
        nextTestId="decision-ingreso-continue-button"
      />
    </Box>
  );
};
